import { takeLatest, put, call } from 'redux-saga/effects';
import * as BulkCaseActions from './action'
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API} from '../../../config'


export function* fetchUploadList(action) {
    let requestUrl = `${CORE_API}/bulkcase/record/${action.data.pageNumber}/${action.data.pageSize}/sort/${action.data.sortField}/${action.data.sortDirection}/${action.data.caseType}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(BulkCaseActions.fetchUploadListSuccess(searchResult.data));
    } catch (err) {
        yield put(BulkCaseActions.fetchUploadListFailure(err.response))
    }
}
export function* getUploadList() {
    yield takeLatest(BulkCaseActions.FETCH_PREVIOUS_UPLOAD_LIST, fetchUploadList);
}

export function* downloadTemplate(action) {
    let requestUrl = `${CORE_API}/bulkcase/template/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(BulkCaseActions.downloadTemplateSuccess(searchResult.data));
    } catch (err) {
        yield put(BulkCaseActions.downloadTemplateFailure(err.response))
    }
}
export function* getBulkCaseTemplate() {
    yield takeLatest(BulkCaseActions.DOWNLOAD_BULK_CASE_TEMPLATE, downloadTemplate);
}

export function* uploadBulk(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    formData.append('caseType', action.data.caseType);
    //RBX-4023: Removed the corportae id from the request params
    // formData.append('corporateId', action.data.corporateId)
    let requestUrl = `${CORE_API}/bulkcase/upload`;
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(BulkCaseActions.uploadBulkCasesSuccess(searchResult.data));
    } catch (err) {
        yield put(BulkCaseActions.uploadBulkCasesFailure(err.response))
    }
}
export function* uploadBulkCases() {
    yield takeLatest(BulkCaseActions.UPLOAD_BULK_CASES, uploadBulk);
}

export function* downloadFile(action) {
    let requestUrl = `${CORE_API}/bulkcase/s3/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(BulkCaseActions.downloadBulkCasesFileSuccess(searchResult.data));
    } catch (err) {
        yield put(BulkCaseActions.downloadBulkCasesFileFailure(err.response))
    }
}
export function* downloadBulkCasesFile() {
    yield takeLatest(BulkCaseActions.DOWNLOAD_BULK_CASES_FILE, downloadFile);
}


export function* uploadQuickBulk(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    formData.append('corporateId', action.data.corporateId)
    let requestUrl = `${CORE_API}/quickreport/upload`;
    try {
        const uploadResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(BulkCaseActions.uploadBulkCasesSuccess(uploadResult.data));
    } catch (err) {
        yield put(BulkCaseActions.uploadBulkCasesFailure(err.response))
    }
}
export function* uploadQuickBulkCases() {
    yield takeLatest(BulkCaseActions.UPLOAD_QUICK_BULK_CASES, uploadQuickBulk);
}